import { mount } from 'svelte';
import App from './App.svelte';
import { initSentry } from './utils/sentry';

initSentry(import.meta.env.VITE_APP_ENV);

const app = mount(App, {
  target: document.getElementById('app')!,
});

export default app;
